import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ChatPage from "./pages/ChatPage";
import AdminPage from "./pages/AdminPage";
import AdvisorPage from "./pages/AdvisorPage";
import EmbedChatPage from "./pages/EmbedChatPage";
import FactoryHypeChatPage from "./pages/FactoryHypeChatPage";
import FactoryHypeV2ChatPage from "./pages/FactoryHypeV2ChatPage";
import HypeConnectChatPage from "./pages/HypeConnectChatPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ChatPage />} />
          <Route path="/hypefactory" element={<ChatPage />} />
          {/* /factoryhype (lokale Jobs) → auf HypeFactory Master-Lea umgeleitet */}
          <Route path="/factoryhype" element={<Navigate to="/hypefactory" replace />} />
          <Route path="/chat/factoryhype" element={<Navigate to="/hypefactory" replace />} />
          <Route path="/factoryhype-v2" element={<FactoryHypeV2ChatPage />} />
          <Route path="/chat/factoryhype-v2" element={<FactoryHypeV2ChatPage />} />
          <Route path="/hypeconnect" element={<HypeConnectChatPage />} />
          <Route path="/chat/hypeconnect" element={<HypeConnectChatPage />} />
          <Route path="/embed" element={<EmbedChatPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/berater" element={<AdvisorPage />} />
          {/* Redirects für alte URLs */}
          <Route path="/chat" element={<Navigate to="/hypefactory" replace />} />
          <Route path="/chat/jobs" element={<Navigate to="/hypefactory" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
